import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faFileText } from '@fortawesome/free-solid-svg-icons';
import { Cliente, ProcessoInfo, ChecklistItem } from '../types';
import { logger } from '../utils/logger';
import { WordExporter } from '../utils/wordExporter';

interface ExportSectionProps {
  cliente: Cliente | null;
  processoInfo: ProcessoInfo;
  checklistItems: ChecklistItem[];
  isVisible: boolean;
}

export const ExportSection: React.FC<ExportSectionProps> = ({
  cliente,
  processoInfo,
  checklistItems,
  isVisible,
}) => {
  const handleExport = async () => {
    if (!cliente) {
      alert('Nenhum cliente selecionado');
      return;
    }

    if (checklistItems.length === 0) {
      alert('Nenhum item no checklist para exportar');
      return;
    }

    if (!processoInfo.tipoProcesso) {
      alert('Por favor, selecione o tipo de processo');
      return;
    }

    if (!processoInfo.nomeClienteApp.trim()) {
      alert('Por favor, preencha o nome do cliente');
      return;
    }

    if (!processoInfo.atividadeEnvio.trim()) {
      alert('Por favor, preencha a atividade de envio');
      return;
    }

    try {
      await WordExporter.exportarChecklist(cliente, processoInfo, checklistItems);
    } catch (error) {
      alert('Erro ao exportar arquivo. Tente novamente.');
      logger.error('Erro na exportação:', error);
    }
  };

  if (!isVisible) return null;

  return (
    <div className="card export-section">
      <div className="card-header">
        <FontAwesomeIcon icon={faFileText} className="card-icon" size={24} />
        <h2>Exportar Checklist</h2>
      </div>
      
      <div className="export-content">
        <div className="export-info">
          <p>Clique no botão abaixo para baixar o checklist em formato Word (.doc)</p>
          <div className="export-details">
            <span><strong>Cliente:</strong> {cliente?.['name_cliente'] || 'Nome não informado'}</span>
            <span><strong>Processo:</strong> {processoInfo.tipoProcesso}</span>
            <span><strong>Documentos:</strong> {checklistItems.length} itens</span>
          </div>
        </div>
        
        <button
          type="button"
          onClick={handleExport}
          className="btn btn-success export-btn"
        >
          <FontAwesomeIcon icon={faDownload} size={20} />
          Exportar para Word
        </button>
      </div>
    </div>
  );
};
